// PAYMENTS EVENTS
export const PAYMENT_CUSTOM_SAVE = 'payment_custom_save';
export const PAYMENT_CUSTOM_PIX_CLICK = 'payment_custom_pix_click';
export const PAYMENT_CUSTOM_WIRE_TRANSFER_CLICK =
  'payment_custom_wire_transfer_click';
export const PAYMENT_CUSTOM_CASH_CLICK = 'payment_custom_cash_click';
export const PAYMENT_CUSTOM_OTHER_CLICK = 'payment_custom_other_click';
export const PAYMENT_PAGE_VIEW = 'payment_page_view';
export const PAYMENT_INTEGRATION_REMOVE_CLICK =
  'payment_integration_remove_click';
export const PAYMENT_INTEGRATION_START = 'payment_integration_start';
export const PAYMENT_METHOD_SELECT = 'payment_method_select';
export const PAYMENT_ADD_CONFIRM = 'payment_add_confirm';
export const PAYMENTS_GATEWAY_SEE_SITE_CLICK =
  'payments_gateway_see_site_click';
export const PAYMENT_CUSTOM_CONFIGURE = 'payment_custom_configure';
export const PAYMENT_CUSTOM_EDIT = 'payment_custom_edit';
export const PAYMENT_INTEGRATION_EDIT_CLICK = 'payment_integration_edit_click';
export const PAYMENT_MP_SYNC_CLICK = 'payment_mp_sync_click';
export const BOLD_SIGNUP_MODAL_CLICK = 'bold_signup_modal_click';
export const BOLD_SIGNIN_MODAL_CLICK = 'bold_signin_modal_click';

// INVOICES EVENTS
export const INVOICES_PAGE_VIEW = 'invoices_page_view';

// CATALOG EVENTS

export const PRODUCT_MENU_CLICK = 'product_menu_click';
export const PRODUCT_MENU_LIST_CLICK = 'product_menu_list_click';

export const PRODUCT_SAVE_CLICK = 'product_save_click';
export const PRODUCT_SAVE_RESULT = 'product_save_result';
export const PRODUCT_SAVE_RESULT_MONDAY = 'product_save_result_monday';

export const PRODUCT_LIST_ORGANIZE_CLICK = 'product_list_organize_click';
export const PRODUCT_LIST_FILTERS_FILTER_CLICK =
  'product_list_filters_filter_click';
export const PRODUCT_LIST_EXPORT_IMPORT_CLICK =
  'product_list_export_import_click';
export const PRODUCT_LIST_ADD_PRODUCT_CLICK = 'product_list_add_product_click';
export const PRODUCT_LIST_ADD_PRODUCT_CLICK_MONDAY =
  'product_list_add_product_click_monday';
export const PRODUCT_LIST_PAGE_VIEW = 'product_list_page_view';
export const PRODUCT_LIST_ADD_PRODUCT_AI_CLICK =
  'product_list_add_product_ai_click';
export const PRODUCT_LIST_ADD_PRODUCT_AI_MODAL_CREATE_CLICK =
  'product_list_add_product_ai_modal_create_click';

export const PRODUCT_ORGANIZE_ACTION_MOVED = 'product_organize_action_moved';

// CORE EVENTS

export const CORE_PRODUCT_ADD_ONBOARDING_CLICK =
  'core_product_add_onboarding_click';
export const CORE_PRODUCT_IMPORT_ONBOARDING_CLICK =
  'core_product_import_onboarding_click';
export const CORE_APP_STORE_DROPSHIPPING_APP_CLICK =
  'core_app_store_dropshipping_app_click';
export const CORE_APP_STORE_DROPSHIPPING_LIST_CLICK =
  'core_app_store_dropshipping_list_click';

//CUSTOMERS EVENTS
export const CUSTOMER_LIST_PAGE_LOAD = 'customer_list_page_load';
export const CUSTOMER_NEW_BUTTON_CLICK = 'customer_new_button_click';
export const CUSTOMER_LIST_CLICK = 'customer_list_click';
export const CUSTOMER_FILTER_CUSTOM_FIELD_CHANGE =
  'customer_filter_custom_field_change';
export const CUSTOMER_NEW_PAGE_LOAD = 'customer_new_page_load';
export const CUSTOMER_NEW_SAVE = 'customer_new_save';
export const CUSTOMER_NEW_CUSTOM_FIELD_CHANGE =
  'customer_new_custom_field_change';
export const CUSTOMER_DETAILS_PAGE_LOAD = 'customer_details_page_load';
export const CUSTOMER_EDIT_BUTTON_CLICK = 'customer_edit_button_click';
export const CUSTOMER_EDIT_PAGE_LOAD = 'customer_edit_page_load';
export const CUSTOMER_EDIT_SAVE = 'customer_edit_save';
export const CUSTOMER_EDIT_CUSTOM_FIELD_CHANGE =
  'customer_edit_custom_field_change';
export const CUSTOMER_TRY_EXPORT = 'customer_try_export';
export const CUSTOMER_FILTER_MODAL_OPEN = 'customer_filter_modal_open';
export const CUSTOMER_FILTER = 'customer_filter';
export const CUSTOMER_SAVE_METAFIELDS = 'customer_save_metafields';
export const CUSTOMER_ALERT_PLANS = 'customer_alert_plans';
export const CUSTOMER_ALERT_CLOSE = 'customer_alert_close';
export const CUSTOMER_CREATE_ADD_PRICETABLES =
  'customer_create_add_pricetables';
export const CUSTOMER_EDIT_ADD_PRICETABLES = 'customer_edit_add_pricetables';
export const CUSTOMER_EDIT_REMOVE_PRICETABLES =
  'customer_edit_remove_pricetables';

// ORDERS EVENTS
export const ORDER_FILTER = 'order_filter';
export const ORDER_SEARCH = 'order_search';
// Used for any functionality that relates to both filtering or searching orders
export const ORDERS_SEARCH_FILTER_CLICK = 'orders_search_filter_click';
export const ORDER_TRANSACTION_ID_LINK_CLICK =
  'order_transaction_id_link_click';
export const ORDER_SELECT_BULK_LINK_CLICK = 'order_select_bulk_link_click';
export const ORDER_METAFIELD_SAVE = 'order_metafield_save';
export const ORDER_METAFIELD_SAVE_ERROR = 'order_metafield_save_error';
export const ORDER_METAFIELD_FILTER = 'order_metafield_filter';
export const ORDER_METAFIELD_FILTER_ERROR = 'order_metafield_filter_error';
export const ORDERS_BULK_METAFIELDS = 'new_admin_orders_bulk_metafields';
export const ORDERS_BULK_METAFIELDS_CANCEL =
  'new_admin_orders_bulk_metafields_cancel';
export const ORDERS_BULK_METAFIELDS_SAVE =
  'new_admin_orders_bulk_metafields_save';
export const ORDER_LIST_EXPORT = 'order_list_export';
export const ORDER_DRAFT_ORDER_CREATE = 'order_draft_order_create';
export const ORDER_DRAFT_ORDER_CREATE_BUTTON_CLICK =
  'order_draft_order_create_button_click';
export const ORDER_LIST_FILTER_CLICK = 'order_list_filter_click';
export const ORDER_LIST_EXPORT_BUTTON_CLICK = 'order_list_export_click';
export const ORDER_LIST_CREATE_DRAFT_ORDER_BUTTON_CLICK =
  'order_list_create_draft_order_click';
export const ORDER_QUICK_ACTION_CLICK = 'order_suggested_action_click';
export const ORDER_SAVED_SEARCH_CREATE_UPSELL =
  'order_saved_search_create_upsell';
export const ORDER_EDIT_CLICK = 'order_edit_click';
export const ORDER_EDIT_SAVE_CLICK = 'order_edit_save_click';
export const ORDER_EDIT_TRACKING_CODE_CLICK = 'order_edit_tracking_code_click';
export const ORDER_EDIT_TRACKING_CODE_SAVE_CLICK =
  'order_edit_tracking_code_save_click';
export const ORDER_BUTTON_PRINT_DOCUMENT = 'order_button_print_document';
export const ORDER_DETAILS_BUTTON_PRINT_LABEL = 'order_button_print_label';
export const ORDER_REOPEN_BUTTON_CLICK = 'order_reopen_button_click';
export const ORDER_REOPEN_WITH_ISSUES_BUTTON_CLICK =
  'order_reopen_with_issues_button_click';
export const ORDER_BUTTON_MARK_AS_PAID_CLICK =
  'order_button_mark_as_paid_click';
export const ORDER_BUTTON_NOTIFY_SHIPPING =
  'order_button_notify_shipping_click';
export const ORDER_BUTTON_COPY_SHIPPING_LINK =
  'order_button_copy_link_shipping_click';
export const ORDER_SELECT_SAVED_SEARCH = 'order_select_saved_search';
export const ORDER_UNSELECT_SAVED_SEARCH = 'order_unselect_saved_search';
export const ORDER_SAVED_SEARCH_CREATE = 'order_saved_search_create';
export const ORDER_SAVED_SEARCH_UPDATE = 'order_saved_search_update';
export const ORDER_SAVED_SEARCH_QUICK_SAVE = 'order_saved_search_quick_save';
export const ORDER_SAVED_SEARCH_QUICK_SAVE_RESULT =
  'order_saved_search_quick_save_result';
export const ORDER_SAVED_SEARCH_CONFIG_OPEN = 'order_saved_search_config_open';
export const ORDER_SAVED_SEARCH_CONFIG_CONFIRM =
  'order_saved_search_config_confirm';
export const ORDER_FILTER_CHIP_CLOSE = 'order_filter-chip-close';
export const ORDERS_CLEAR_FILTERS = 'orders_clear_filters_click';
export const ORDERS_NE_CLOSE_PROMOTION_BANNER =
  'order_nuvem_envio_close_promotion_banner';
export const ORDERS_NE_VIEW_PROMOTION_BANNER =
  'order_nuvem_envio_view_promotion_banner';
export const ORDERS_NE_ACCEPT_PROMOTION_BANNER =
  'order_nuvem_envio_accept_promotion_banner';
export const ORDERS_LAST_PAGE_CLICK = 'orders_last_page_click';
export const ORDERS_UNPACK_CLICK = 'orders_unpack_click';
export const ORDERS_UNPACK_CONFIRM = 'orders_unpack_confirm';
export const BACK_TO_PREVIOS_VERSION_CLICK = 'back_to_previos_version_click';
export const ORDERS_AUTO_CANCEL_BUTTON_CLICK = 'orders_autocancel_button_click';
export const ORDERS_AUTO_CANCEL_PROMOTIONAL_MODAL_ACTIVATE_CLICK =
  'orders_autocancel_promotional_modal_activate_click';
export const ORDERS_AUTO_CANCEL_SAVE_CONFIGURATION =
  'orders_autocancel_save_configuration';
export const ORDERS_AUTO_CANCEL_PIX_CONFIGURATION_CLICK =
  'orders_autocancel_pix_configuration_click';
export const ORDERS_AUTO_CANCEL_NUVEMPAGO_ACTIVATION =
  'orders_autocancel_nuvempago_activation';
export const ORDERS_STOCK_ISSUES_BUTTON_CLICK =
  'orders_stock_issues_filter_click';
export const ORDERS_STOCK_ISSUES_ALERT_DISMISS =
  'orders_stock_issues_alert_dismiss';
export const ORDERS_STOCK_ISSUES_SHOW_ALERT = 'orders_stock_issues_show_alert';
export const ORDER_ABANDONED_CART_SEND_WHATSAPP_CLICK =
  'order_abandoned_cart_send_whatsapp_click';

export const ORDERS_CHARGEBACK_EXIT_BUTTON_CLICK =
  'orders_chargeback_exit_button_click';
export const ORDERS_CHARGEBACK_ORDER_CLICK = 'orders_chargeback_order_click';
export const ORDERS_CHARGEBACK_NUVEMPAGO_CLICK =
  'orders_chargeback_nuvempago_click';

export const ORDERS_CHARGEBACK_DEADLINE_EXIT_BUTTON_CLICK =
  'orders_chargeback_deadline_exit_button_click';
export const ORDERS_CHARGEBACK_DEADLINE_ORDER_CLICK =
  'orders_chargeback_deadline_order_click';
export const ORDERS_CHARGEBACK_DEADLINE_NUVEMPAGO_CLICK =
  'orders_chargeback_deadline_nuvempago_click';

// DRAFT ORDERS
export const DRAFT_ORDER_MARK_AS_PAID_BUTTON_CLICK =
  'draft_order_mark_as_paid_button_click';
export const DRAFT_ORDER_WITH_STOCK_ISSUES_CONFIRM_BUTTON_CLICK =
  'draft_order_with_stock_issues_confirm_button_click';
export const DRAFT_ORDER_WITH_STOCK_ISSUES_CANCEL_BUTTON_CLICK =
  'draft_order_with_stock_issues_cancel_button_click';
export const DRAFT_ORDER_WITH_STOCK_ISSUES_UNDERSTOOD_BUTTON_CLICK =
  'draft_order_with_stock_issues_understood_button_click';
// NUVEMPAGO
export const NUVEMPAGO_MENU_CLICK = 'click-nuvem-pago-menu';
export const PAYMENTS_METHODS_NUVEMPAGO_ACTIVATE_CLICK =
  'payments_methods_nuvempago_activate_click';
export const PAYMENTS_METHODS_NUVEMPAGO_DEACTIVATE_CLICK =
  'payments_methods_nuvempago_deactivate_click';
export const PAYMENTS_METHODS_MODAL_NUVEMPAGO_DEACTIVATE_CLICK =
  'payments_methods_modal_nuvempago_deactivate_click';
export const NUVEMPAGO_MANUAL_ACTIVATION_REGISTRATION_ACTIVATE_CLICK =
  'nuvempago_manual_activation_registration_activate_click';

// 2FA EVENTS
export const AUTHENTICATION_FACTOR_ACTIVATED =
  'authentication-factor-activated';
export const AUTHENTICATION_FACTOR_DEACTIVATED =
  'authentication-factor-deactivated';
export const AUTHENTICATION_FACTOR_RECOVERY_CODES_COPIED =
  'two_steps_verification_recovery_key_copy_button_click';
export const AUTHENTICATION_FACTOR_RECOVERY_CODES_DOWNLOADED =
  'two_steps_verification_recovery_key_download_button_click';
export const AUTHENTICATION_FACTOR_RECOVERY_CODES_START_ACTIVATION =
  'two_steps_verification_activate_key_button_click';
export const AUTHENTICATION_FACTOR_RECOVERY_CODES_UPDATE =
  'two_steps_verification_update_recovery_key_button_click';
export const AUTHENTICATION_FACTOR_LOGIN_WITH_RECOVERY_CODES =
  'login_access_with_key_recovery_confirm_button_click';
export const AUTHENTICATION_FACTOR_RECOVERY_CODES_HELP_LINK_CLICKED =
  'login_access_with_key_recovery_help_button_click';
export const DASHBOARD_RECOVERY_CODES_UPDATE_AFTER_LOGIN =
  'general_login_modal_access_with_key_recovery_update_button_click';

// SESSION MANAGEMENT EVENTS
export const SESSION_MANAGEMENT_MENU_ITEM_CLICK =
  'session_management_menu_item_click';
export const SESSION_MANAGEMENT_CLOSE_SESSION_BUTTON_CLICK =
  'session_management_close_session_button_click';
export const SESSION_MANAGEMENT_CLOSE_ALL_SESSIONS_BUTTON_CLICK =
  'session_management_close_all_sessions_button_click';

// BILLING EVENTS
export const BILLING_VIEW_PLANS_PAGE = 'billing_view_plans_page';
export const BILLING_GO_TO_PAY_PLAN_CLICK = 'billing_go_to_pay_plan_click';
export const BILLING_CHANGE_PLAN_CLICK = 'billing_change_plan_click';
export const BILLING_GO_TO_ANNUAL_DISCOUNT = 'billing_go_to_annual_discount';
export const BILLING_UPSELL_MODAL_SHOW = 'billing_upsell_modal_show';
export const BILLING_UPSELL_MODAL_CLOSE = 'billing_upsell_modal_close';
export const BILLING_UPSELL_PLAN_CHANGE = 'billing_upsell_plan_change';
export const BILLING_DOWNGRADE_PLAN = 'billing_downgrade_plan';
export const BILLING_UPSELL_PLANS_PAGE_CLICK =
  'billing_upsell_modal_plans_page_click';
export const BILLING_POST_UPSELL_ADBAR_CLICK = 'post_upsell_adbar_click';
export const BILLING_PLAN_DEBT_ADBAR_CLICK = 'post_plan_debt_adbar_click';
export const BILLING_FAILED_PAYMENT_ALERT_PAY_CLICK =
  'billing_failed_payment_alert_pay_click';
export const BILLING_SOFT_BLOCK_PAYMENT_CLICK =
  'billing_soft_block_payment_click';
export const BILLING_SOFT_BLOCK_MODAL_SHOW = 'billing_soft_block_modal_show';
export const BILLING_HARD_BLOCK_MODAL_SHOW = 'billing_hard_block_modal_show';
export const BILLING_HARD_BLOCK_PAYMENT_CLICK =
  'billing_hard_block_payment_click';
export const BILLING_CANCEL_SCHEDULED_DOWNGRADE_CLICK =
  'billing_cancel_scheduled_downgrade_click';
export const BILLING_CANCEL_SCHEDULED_DOWNGRADE_CONFIRM =
  'billing_cancel_scheduled_downgrade_confirm';

export const BILLING_VIEW_CHECKOUT_CHARGES = 'billing_view_checkout_charges';
export const BILLING_VIEW_CHECKOUT_CHARGES_AFTER_PAYMENT =
  'billing_view_checkout_charges_after_payment';
export const BILLING_CHECKOUT_START_PAYMENT =
  'billing_checkout_start_payment_click';
export const BILLING_VIEW_CHECKOUT_SELECT_METHOD_FOR_PLAN =
  'billing_view_checkout_select_method_for_plan';
export const BILLING_CHECKOUT_SELECT_METHOD_FOR_PLAN_CLICK =
  'billing_checkout_select_method_for_plan_click';
export const BILLING_CHECKOUT_SELECT_RECURRENCY_CLICK =
  'billing_checkout_select_recurrency_click';
export const BILLING_VIEW_CHECKOUT_PAY_CREDIT_CARD =
  'billing_view_checkout_pay_credit_card';
export const BILLING_CHECKOUT_CREDIT_CARD_PAY_CLICK =
  'billing_checkout_credit_card_pay_click';
export const BILLING_VIEW_CHECKOUT_PAY_WIRE_TRANSFER =
  'billing_view_checkout_pay_wire_transfer';
export const BILLING_CHECKOUT_WIRE_TRANSFER_PAY_CLICK =
  'billing_checkout_wire_transfer_pay_click';
export const BILLING_CHANGE_PLANS_CLICK = 'billing_checkout_change_plan_click';
export const BILLING_RECURRING_CANCEL_CLICK =
  'billing_checkout_cancel_recurrent_payment_click';
export const BILLING_LAST_PAYMENTS = 'billing_checkout_last_payments';
export const BILLING_CHECKOUT_VIEW_DETAILS = 'billing_checkout_view_details';
export const TEST_DISCOUNTS_ADBAR_SHOW = 'test_discounts_adbar_show';
export const TEST_DISCOUNTS_ADBAR_CLICK = 'test_discounts_adbar_click';
export const BILLING_PAYORDER_CHECKOUT_VIEW =
  'billing_view_new_checkout_pay_order';
export const BILLING_PAYORDER_CHECKOUT_CONTINUE_CLICK =
  'billing_new_checkout_pay_order_start_payment_click';
export const BILLING_PAYORDER_CHECKOUT_FINISH =
  'billing_new_checkout_pay_order_finish';
export const BILLING_LAST_PAYMENTS_TAB_CLICK =
  'billing_last_payments_tab_click';
export const BILLING_CHURN_STATUS_CHECK = 'billing_churn_status_check';
export const BILLING_REACTIVATE_STORE_CLICK = 'billing_reactivate_store_click';
export const BILLING_CHECKOUT_TRANSACTION_FEES_RP_CHECKBOX =
  'billing_checkout_transaction_fees_rp_checkbox';
export const BILLING_CHECKOUT_CREDIT_CARD_FAILURE_CHANGE_METHOD =
  'billing_checkout_credit_card_failure_change_method';
export const BILLING_UPSELL_DISCOUNT_SHOW = 'billing_upsell_discount_show';
export const BILLING_UPSELL_DISCOUNT_CLOSE = 'billing_upsell_discount_close';
export const BILLING_ADBAR_DISCOUNT_UPGRADE_SHOW =
  'billing_adbar_discount_upgrade_show';
export const BILLING_ADBAR_DISCOUNT_UPGRADE_CLICK =
  'billing_adbar_discount_upgrade_click';
export const BILLING_UPSELL_DISCOUNT_CLICK = 'billing_upsell_discount_click';

// PARTNERS EVENTS
export const PARTNERS_APPS_ADD_CLICK = 'partners_apps_add_click';
export const MENU_PRIMARY_APPS_CLICK = 'menu_primary_apps_click';

// SHIPPING EVENTS
export const SHIPPING_DISTRIBUTION_CENTER_DEFINE =
  'shipping_distribution_center_define';
export const SHIPPING_DISTRIBUTION_CENTER_ADD =
  'shipping_distribution_center_add';
export const SHIPPING_VIEWED_METHOD = 'shipping_viewed_method';
export const SHIPPING_SAVED_METHODS = 'shipping_saved_method';
export const SHIPPING_APPS_MORE_CLICK = 'shipping-apps_more_click';
export const SHIPPING_DISTRIBUTION_CENTER_CREATED_NAVIGATION =
  'shipping_distribution_center_created_navigation';
export const SHIPPING_ADD_DISTRIBUTION_CENTER =
  'shipping_add_distribution_center';
export const SHIPPING_ENABLE_MULTICD_BY_CD = 'shipping_enable_multicd_by_cd';
export const SHIPPING_EDIT_DISTRIBUTION_CENTER =
  'shipping_edit_distribution_center';
export const SHIPPING_DELETE_DISTRIBUTION_CENTER =
  'shipping_delete_distribution_center';
export const SHIPPING_DELETE_DISTRIBUTION_CENTER_SUBMIT =
  'shipping_delete_distribution_center_submit';
export const SHIPPING_UPGRADE_MODAL_SEE_PLANS_CLICK =
  'shipping_upgrade_modal_see_plans_click';
export const SHIPPING_UPGRADE_CARD_SEE_PLANS_CLICK =
  'shipping_upgrade_modal_see_plans_click';
export const SHIPPING_DISTRIBUTION_CENTER_NOW_ALLOWED =
  'shipping_distribution_center_now_allowed';
export const SHIPPING_NAVIGATE_TO_DISTRIBUTION_CENTER =
  'shipping_navigate_to_distribution_center';
export const SHIPPING_CREATE_SECONDARY_CD_BY_ADDRESSING_RULE_CARD =
  'shipping_create_secondary_cd_by_addressing_rule_card';
export const SHIPPING_OPEN_ADDRESSING_RULE_MODAL =
  'shipping_open_addressing_rule_modal';
export const SHIPPING_EDIT_ADDRESSING_RULES = 'shipping_edit_addressing_rules';
export const SHIPPING_LOCATIONS_PRIORITY_MODAL =
  'shipping_locations_priority_modal';
export const SHIPPING_CHANGE_ADDRESSING_RULE =
  'shipping_change_addressing_rule';
export const SHIPPING_CLOSE_ADDRESSING_RULE_MODAL =
  'shipping_close_addressing_rule_modal';
export const SHIPPING_PRINT_DOCUMENT_PAGE_VIEW =
  'shipping_print_document_page_view';
export const SHIPPING_PRINT_DOCUMENT_SETTING = 'shipping_print_receipt_setting';
export const SHIPPING_PRINT_DOCUMENT_CANCEL_BUTTON_CLICK =
  'shipping_print_document_cancel_button_click';
export const SHIPPING_PRINT_DOCUMENT_CONFIRMATION_BUTTON_CLICK =
  'shipping_print_document_confirmation_button_click';

// STATS EVENTS
export const STATS_SEE_PLANS_CLICK = 'stats_see_plans_click';
export const STATS_TRIAL_BAR_CLICK = 'stats_trial_bar_click';

// STATS MENU EVENTS (V1)
export const MENU_PRIMARY_STATS_CLICK = 'menu_primary_stats_click';
export const MENU_SECONDARY_STATS_CLICK = 'menu_secondary_stats_click';
export const MENU_SECONDARY_STATS_PRODUCTS_CLICK =
  'menu_secondary_stats_products_click';
export const MENU_SECONDARY_STATS_PAYMENTS_CLICK =
  'menu_secondary_stats_payments_click';
export const MENU_SECONDARY_STATS_ACQUISITION_CLICK =
  'menu_secondary_stats_acquisition_click';
export const MENU_SECONDARY_STATS_SHIPPING_CLICK =
  'menu_secondary_stats_shipping_click';

// STATS MENU EVENTS (V2)
export const MENU_SECONDARY_STATS_GENERAL_CLICK =
  'menu_secondary_stats_general_click';
export const MENU_SECONDARY_STATS_LIVEVIEW_CLICK =
  'menu_secondary_stats_liveview_click';
export const MENU_SECONDARY_STATS_COUPONS_CLICK =
  'menu_secondary_stats_coupons_click';
export const MENU_SECONDARY_STATS_SEARCH_INSIGHTS_CLICK =
  'menu_secondary_stats_search_insights_click';
export const MENU_SECONDARY_STATS_VISITS_CLICK =
  'menu_secondary_stats_visits_click';
export const MENU_SECONDARY_STATS_SALES_CLICK =
  'menu_secondary_stats_sales_click';
export const MENU_SECONDARY_STATS_PRODUCTS_V2_CLICK =
  'menu_secondary_stats_products_v2_click';

// COMMONS EVENTS
export const UPGRADE_SEE_PLANS_CLICK = 'upgrade_see_plans_click';
export const HELP_TUTORIAL_CLICK = 'help_tutorial_click';
export const MENU_CONFIGURATION_CLICK = 'menu_configuration_click';
export const MENU_COLLAPSE_TOGGLE_EXPAND = 'menu_collapse_toggle_expand';
export const MENU_COLLAPSE_TOGGLE_COLLAPSE = 'menu_collapse_toggle_collapse';

// PAGO NUBE EVENTS

export const CLICK_ACTIVATE_NUVEM_PAGO_PAYMENT_METHODS =
  'click-activate-nuvem-pago-payment-methods';
export const CLICK_ACTIVATE_NUVEM_PAGO_MODAL_DOCUMENT =
  'click-activate-nuvem-pago-modal-document';
export const SUCCESS_ACTIVATION_NUVEM_PAGO = 'success-activation-nuvem-pago';
export const PAGO_NUBE_ONBOARDING_MODAL_SEE_SETTINGS_CLICK =
  'pago_nube_onboarding_modal_see_settings_click';

// NUVEM PAGO NUBE EVENTS
export const NUVEMPAGO_ONBOARDING_MODAL_SEE_SETTINGS_CLICK =
  'nuvempago_onboarding_modal_see_settings_click';
export const PAYMENT_NUVEM_PAGO_PAYMENTS_MENU_EDIT_CLICK =
  'payment_nuvem_pago_payments_menu_edit_click';
export const PAYMENT_NUVEM_PAGO_PAYMENTS_MENU_REMOVE_CLICK =
  'payment_nuvem_pago_payments_menu_remove_click';
export const PAYMENT_NUVEM_PAGO_PAYMENTS_MENU_DEADLINE_FEES_CLICK =
  'payment_nuvem_pago_payments_menu_deadline_fees_click';
export const PAYMENT_NUVEM_PAGO_PAYMENTS_MENU_ACCOUNT_CLICK =
  'payment_nuvem_pago_payments_menu_account_click';
export const PAYMENT_MODAL_OTHERSPLANS_REMOVE_NUVEMPAGO_REMOVE_CLICK =
  'payment_modal_otherplans_remove_nuvempago_remove_click';
export const PAYMENT_MODAL_NEXT_REMOVE_NUVEMPAGO_REMOVE_CLICK =
  'payment_modal_next_remove_nuvempago_remove_click';
export const PAYMENT_MODAL_FREEMIUM_REMOVE_NUVEMPAGO_REMOVE_CLICK =
  'payment_modal_freemium_remove_nuvempago_remove_click';
export const NUVEMPAGO_MANUAL_ACTIVATION_REGISTRATION_CAN_CLICK =
  'nuvempago_manual_activation_registration_can_click';

// NUVEM PAGO PAYMENT PROVIDER STATUS EVENTS
export const PAYMENTS_METHODS_NUVEMPAGO_DISABLED_STATUS =
  'payments_methods_nuvempago_disabled_status';
export const PAYMENTS_METHODS_NUVEMPAGO_INPROCESS_STATUS =
  'payments_methods_nuvempago_inprocess_status';
export const PAYMENTS_METHODS_NUVEMPAGO_PENDING_STATUS =
  'payments_methods_nuvempago_pending_status';
export const PAYMENTS_METHODS_NUVEMPAGO_ACTIVATED_STATUS =
  'payments_methods_nuvempago_activated_status';

// THEMES EVENTS
export const MENU_SECONDARY_PREFERENCES_CLICK =
  'menu_secondary_preferences_click';
export const MENU_SECONDARY_PASSWORD_PROTECTED_CLICK =
  'menu_secondary_password_protected_click';
export const MENU_SECONDARY_THEMES_CLICK = 'menu_secondary_themes_click';
export const THEME_LAYOUT_CUSTOMIZE_CURRENT = 'theme_layout_customize_current';
export const THEME_FTP_ENABLE = 'theme_ftp_enable';
export const THEME_FTP_DISABLE = 'theme_ftp_disable';
export const THEME_LAYOUT_CUSTOMIZE_DRAFT = 'theme_layout_customize_draft';
export const THEME_LAYOUT_CHANGE = 'theme_layout_change';
export const THEME_SELECTION_UPDATED = 'theme_selection_updated';
export const THEME_LAYOUT_DRAFT_ACTIONS_VIEW =
  'theme_layout_draft_actions_view';
export const THEME_LAYOUT_DRAFT_PUBLISH = 'theme_layout_draft_publish';
export const THEME_LAYOUT_DRAFT_DELETE = 'theme_layout_draft_delete';
export const THEME_LAYOUT_DRAFT_CREATION = 'theme_layout_draft_creation';
export const THEME_LAYOUT_DRAFT_CREATION_DEFAULT =
  'theme_layout_draft_creation_default';
export const THEME_LAYOUT_DRAFT_CREATION_OTHERS =
  'theme_layout_draft_creation_others';

// PAGES EVENTS
export const MENU_SECONDARY_PAGES_CLICK = 'menu_secondary_pages_click';

// WHATSAPP EVENTS
export const MENU_SECONDARY_WHATSAPP_CLICK = 'menu_secondary_whatsapp_click';
export const WHATSAPP_ENABLE_CHATBUTTON = 'whatsapp_enable_chatbutton';
export const WHATSAPP_DISABLE_CHATBUTTON = 'whatsapp_disable_chatbutton';
export const WHATSAPP_EDIT_NUMBER_CLICK = 'whatsapp_edit_number_click';

// NAVIGATION EVENTS
export const MENU_SECONDARY_NAVIGATION_CLICK =
  'menu_secondary_navigation_click';
export const MENU_STORE_VISIT = 'menu_store_visit';
export const MENU_SECONDARY_BLOG_CLICK = 'menu_secondary_blog_click';
export const MENU_SECONDARY_HIRE_PARTNER_CLICK =
  'menu_secondary_hire_partner_click';

// ACCOUNT MENU EVENTS
export const MENU_PRIMARY_ACCOUNT_CLICK = 'menu_primary_user_account_click';
export const D2C_BOTAO_CLICK = 'D2C_botão_click';

// STORE DOMAINS EVENTS
export const MENU_SECONDARY_DOMAINS_CLICK = 'menu_secondary_domains_click';
export const ADD_DOMAIN_CLICK = 'domains_associate';
export const DELETE_DOMAIN_CLICK = 'domains_delete';
export const CREATE_DOMAIN_SUBMIT_CLICK = 'domain_create_submit';
export const DOMAINS_ERROR_ALERT_DASHBOARD_CLICK =
  'domains_error_alert_dashboard_click';
export const DOMAINS_ERROR_ALERT_DASHBOARD_DISMISS =
  'domains_error_alert_dashboard_dismiss';
export const DOMAIN_ERROR_REVIEW_CLICK = 'domain_error_review_link_click';
export const DOMAINS_ERROR_ALERT_DASHBOARD_SHOW =
  'domains_error_alert_dashboard_show';
export const NUVEM_DOMAINS_MANUAL_CONFIG_CLICK =
  'nuvem_domains_manual_config_click';
export const NUVEM_DOMAINS_START_BUY_CLICK = 'nuvem_domains_start_buy_click';
export const NUVEM_DOMAINS_SEARCH = 'nuvem_domains_search';
export const NUVEM_DOMAINS_AVAILABLE = 'nuvem_domains_available';
export const NUVEM_DOMAINS_NOT_AVAILABLE = 'nuvem_domains_not_available';
export const NUVEM_DOMAINS_BUY_CLICK = 'nuvem_domains_buy_click';
export const NUVEM_DOMAINS_CHECKOUT = 'nuvem_domains_checkout';
export const NUVEM_DOMAINS_PAY_CLICK = 'nuvem_domains_pay_click';
export const NUVEM_DOMAINS_PAYMENT_PROCESS = 'nuvem_domains_payment_process';
export const NUVEM_DOMAINS_PAYMENT_REJECTED = 'nuvem_domains_payment_rejected';
export const NUVEM_DOMAINS_ERROR = 'nuvem_domains_error';
export const NUVEM_DOMAINS_VALIDATION_PROCESS =
  'nuvem_domains_validation_process';
export const NUVEM_DOMAINS_VALIDATION_PROCESS_RESEND_CLICK =
  'nuvem_domains_validation_process_resend_click';

// PREFERENCES CHECKOUT EVENTS
export const MENU_SECONDARY_PREFERENCES_CHECKOUT =
  'menu_secondary_preferences_checkout_click';

// USERS PERMISSIONS
export const MENU_SECONDARY_USERS_PERMISSIONS_CLICK =
  'menu_secondary_users_click';

export const MENU_SECONDARY_EDIT_USER_CLICK = 'menu_secondary_edit_user_click';

// NOTIFICATIONS
export const MENU_SECONDARY_NOTIFICATIONS_CLICK =
  'menu_secondary_notifications_click';
export const CNAME_CONFIG_CAN_CLICK = 'cname_config_can_click';
export const EMAIL_NOTIFICATION_ENABLED_CLICK =
  'email_notification_enabled_click';

// NUVEM ENVIO EVENTS
export const NUVEM_ENVIO_CLICK = 'nuvemenvio_click';
export const OPEN_ORDERS_NUVEM_ENVIO_DASHBOARD = 'open_nuvem_envio_dashboard';
export const NUVEM_ENVIO_VIEW = 'nuvemenvio_view';
export const NUVEMVIO_JADLOG_WELCOME_PAGE = 'Shipping options - Jadlog welcome';
export const NUVEMVIO_LOGGI_WELCOME_PAGE = 'Shipping options - Loggi welcome';
export const NUVEMEVIO_SHIPPING_ACTION_LINK = 'Go to dropoff point';
export const NUVEM_ENVIO_COMMUNICATION = 'nuvemenvio_communication';
export const NUVEM_ENVIO_PRINT_LABELS_VIEW =
  'nuvemenvio_loading_print_label_view';
export const NUVEM_ENVIO_PRINT_LABELS_VIEW_ERROR =
  'nuvemenvio_orders_print_label_toast_failure_view';
export const NUVEM_ENVIO_PRINT_LABELS_VIEW_SUCCESS =
  'nuvemenvio_orders_print_label_toast_success_view';
export const NUVEM_ENVIO_PRINT_LABELS_VIEW_WAITING_PAYMENT =
  'nuvemenvio_processing_payment_view';
export const NUVEM_ENVIO_PRINT_LABELS_BUTTON_ORDER_DETAILS =
  'nuvemenvio_order_button_label_print';
export const NUVEM_ENVIO_PRINT_LABELS_MODAL_VIEW =
  'nuvemenvio_print_labels_view';
export const NUVEM_ENVIO_PRINT_LABELS_MODAL_CANCEL_BUTTON =
  'nuvemenvio_print_labels_cancel_click';
export const NUVEM_ENVIO_PRINT_LABELS_MODAL_CONTINUE_BUTTON =
  'nuvemenvio_print_labels_continue_click';
export const NUVEM_ENVIO_PRINT_LABELS_VIEW_WAITING_PAYMENT_BUTTON =
  'nuvemenvio_processing_payment_back_click';
export const NUVEM_ENVIO_CYBER_MONDAY_BANNER_CLICK =
  'nuvemenvio_home_banner_cyber_monday_contact_click';
export const NUVEM_ENVIO_CYBER_MONDAY_BANNER_CLOSE =
  'nuvemenvio_home_banner_cyber_monday_close';
export const NUVEM_ENVIO_BLACK_FRIDAY_BANNER_CLICK =
  'nuvemenvio_home_banner_black_friday_contact_click';
export const NUVEM_ENVIO_BLACK_FRIDAY_BANNER_CLOSE =
  'nuvemenvio_home_banner_black_friday_close_click';
export const NUVEM_ENVIO_LOGGI_BANNER_CLICK =
  'nuvemenvio_home_banner_loggi_contact_click';
export const NUVEM_ENVIO_LOGGI_BANNER_CLOSE =
  'nuvemenvio_home_banner_loggi_close_click';
export const NUVEM_ENVIO_CYBER_MONDAY_RATE_BANNER_CLICK =
  'nuvemenvio_home_banner_cyber_monday_activate_click';
export const NUVEM_ENVIO_CYBER_MONDAY_RATE_BANNER_CLOSE =
  'nuvemenvio_home_banner_cyber_monday_activate_close_click';
export const NUVEM_ENVIO_CUSTOM_ORDER_BANNER_CLOSE =
  'nuvemenvio_custom_shipping_alert_close';
export const NUVEM_ENVIO_CUSTOM_ORDER_BANNER_CLICK =
  'nuvemenvio_custom_shipping_CAN_click';
export const NUVEM_ENVIO_LOGGI_BANNER_ACTIVATE_BUTTON_CLICK =
  'loggi_coleta_activate_banner_button_click';
export const NUVEM_ENVIO_LOGGI_BANNER_CLOSE_BUTTON_CLICK =
  'loggi_coleta_dismiss_banner_button_click';
export const NUVEM_ENVIO_PRINT_DOCUMENTS_PAGE_VIEW =
  'nuvemenvio_label_print_view';
export const NUVEM_ENVIO_PRINT_DOCUMENTS_BUTTON_CANCEL_CLICK =
  'nuvemenvio_label_cancel_click';
export const NUVEM_ENVIO_PRINT_DOCUMENTS_BUTTON_CONFIRM_CLICK =
  'nuvemenvio_label_print_click';
export const NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATING_START_LABELS =
  'nuvemenvio_shipping_label_generate_start';
export const NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATED_SUCCESS_LABELS =
  'nuvemenvio_shipping_label_generate_success';
export const NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATED_ERROR_LABELS =
  'nuvemenvio_shipping_label_generate_error';
export const NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATED_PRINT_LABELS_CLICK =
  'nuvemenvio_shipping_label_print_click';

// NUVEM ENVIO POPOVER UNPACKED EVENTS
export const NUVEM_ENVIO_POPOVER_UNPACKED_VIEW =
  'nuvemenvio_popover_unpacked_view';
export const NUVEM_ENVIO_POPOVER_UNPACKED_CLOSE =
  'nuvemenvio_popover_unpacked_close';
export const NUVEM_ENVIO_POPOVER_UNPACKED_CLICK =
  'nuvemenvio_popover_unpacked_click';

// NUVEM ENVIO POPOVER UNPACKED CONSTANTS
export const NUVEM_ENVIO_POPOVER_UNPACKED_PAGE = 'orders';
export const NUVEM_ENVIO_POPOVER_UNPACKED_TYPE = 'nuvem_envio_unpacked';
export const NUVEM_ENVIO_POPOVER_UNPACKED_VIEW_ACTION =
  'nuvem_envio_popover_view';
export const NUVEM_ENVIO_POPOVER_UNPACKED_CLOSE_ACTION =
  'nuvem_envio_popover_close_icon_click';
export const NUVEM_ENVIO_POPOVER_UNPACKED_LINK_ACTION =
  'nuvem_envio_popover_save_on_shipping_link_click';

// DASHBOARD EVENTS
export const MENU_PRIMARY_HOME_CLICK = 'menu_primary_home_click';
export const DASHBOARD_ORDERS_FREQUENT_ACCESS_WAITING_PAYMENT_ALL =
  'dashboard_orders_frequent_access_waiting_payment_all';
export const DASHBOARD_ORDERS_FREQUENT_ACCESS_WAITING_SHIPPING_ALL =
  'dashboard_orders_frequent_access_waiting_shipping_all';
export const DASHBOARD_ORDERS_FREQUENT_ACCESS_WAITING_PACKING =
  'dashboard_orders_frequent_access_waiting_packing';
export const DASHBOARD_ORDERS_FREQUENT_ACCESS_SAVED_SEARCH =
  'dashboard_orders_frequent_access_saved_search';
export const DASHBOARD_SELECT_THEME_CLICK = 'dashboard_select_theme_click';
export const DASHBOARD_ADD_PRODUCT_CLICK = 'dashboard_add_product_click';
export const DASHBOARD_SHIPPING_CLICK = 'dashboard_shipping_click';
export const DASHBOARD_PAYMENTS_CLICK = 'dashboard_payments_click';
export const ONBOARDING_ENP_CLICK = 'onboarding_enp_click';
export const ONBOARDING_ENA_CLICK = 'onboarding_ena_click';
export const DASHBOARD_SELECT_STATISTICS_CLICK =
  'dashboard_select_statistics_click';
export const DAHSBOARD_ADDITIONAL_SETTINGS_CLICK =
  'dashboard_additional_settings_click';
export const DASHBOARD_FREE_COURSES_CLICK = 'dashboard_free_courses_click';
export const DASHBOARD_BOOST_STORE_CLICK = 'dashboard_boost_store_click';
export const DASHBOARD_2FA_CLICK = 'dashboard_2fa_click';
export const DASHBOARD_2FA_WARNING_CLICK = 'dashboard_2fa_warning_click';
export const DASHBOARD_2FA_LIMITED_ACCESS_CLICK =
  'dashboard_2fa_limited_access_click';
export const DASHBOARD_BILLING_TRANSACTION_FEES_PAGE_CLICK =
  'dashboard_billing_transaction_fees_page_click';
export const DASHBOARD_BILLING_TRANSACTION_FEES_PAYMENT_AVAILABLE_CLICK =
  'dashboard_billing_tx_fees_page_from_reminder_modal_click';
export const DASHBOARD_BILLING_TX_FEES_PAGE_FROM_REMINDER_MODAL_CLICK =
  'dashboard_billing_tx_fees_page_from_reminder_modal_click';
export const DASHBOARD_TRANSACTION_FEES_FREE_NUVEM_PAGO_CLICK =
  'dashboard_transaction_fees_free_nuvem_pago_click';

export const CLOUDFLARE_MIGRATION_ADBAR_CLICK =
  'cloudflare_migration_adbar_click';

export const CLOUDFLARE_SOFTBLOCK_UPDATED_CLICK =
  'cloudflare-softblock-updated_click';

export const CLOUDFLARE_SOFTBLOCK_TUTORIAL_CLICK =
  'cloudflare-softblock-tutorial_click';

export const CLOUDFLARE_SOFTBLOCK_SKIP_CLICK =
  'cloudflare-softblock-skip_click';

export const DASHBOARD_ONLINE_STORE_ACTIVATE_CLICK =
  'dashboard_loja_online_activate';

export const OTP_MODAL_RECOMMENDATIONS_CLICK =
  'otp_modal_recommendations_click';
export const OTP_MODAL_RECOMMENDATIONS_SHOW = 'otp_modal_recommendations_show';

// DISCOUNTS
export const MORE_DISCOUNTS_MODAL_OPENED = 'more_discounts_modal_opened';
export const MORE_DISCOUNTS_MODAL_OPTION_CLICK =
  'more_discounts_modal_option_click';
export const MORE_DISCOUNTS_MODAL_OPTION_CREATED =
  'more_discounts_modal_option_created';

// PROMOTIONS
export const MENU_SECONDARY_PROMOTION_LIST_CLICK =
  'menu_secondary_promotions_list_click';
export const PROMOTIONS_CREATION_VIEW = 'promotions_creation_view';
export const PROMOTIONS_SHOW_ADOPTION_ALERT = 'promotions_show_adoption_alert';
export const PROMOTIONS_OPEN_ADOPTION_ALERT = 'promotions_open_adoption_alert';
export const PROMOTIONS_CLOSE_ADOPTION_ALERT =
  'promotions_close_adoption_alert';

// COUPONS
export const COUPONS_FILTERED = 'marketing_coupons_filter';
export const COUPONS_ORDERED = 'marketing_coupons_order';
export const ACCESS_EDIT_COUPON_PAGE = 'marketing_coupons_access_edit_page';
export const EXIT_EDIT_COUPON_PAGE = 'marketing_coupons_exit_edit_page';
export const COUPONS_SHOW_ADOPTION_ALERT = 'coupons_show_adoption_alert';
export const COUPONS_OPEN_ADOPTION_ALERT = 'coupons_open_adoption_alert';
export const COUPONS_CLOSE_ADOPTION_ALERT = 'coupons_close_adoption_alert';

// FREE SHIPPING
export const MENU_SECONDARY_FREE_SHIPPING_LIST_CLICK =
  'menu_secondary_free_shipping_list_click';
export const FREE_SHIPPING_SHOW_ADOPTION_ALERT =
  'free_shipping_show_adoption_alert';
export const FREE_SHIPPING_OPEN_ADOPTION_ALERT =
  'free_shipping_open_adoption_alert';
export const FREE_SHIPPING_CLOSE_ADOPTION_ALERT =
  'free_shipping_close_adoption_alert';

// EXTERNAL CODES
export const MENU_SECONDARY_PREFERENCES_ADVANCED_CLICK =
  'menu_secondary_preferences_advanced_click';
export const MENU_SETTINGS_EXTERNALCODES_VIEW =
  'menu_settings_externalcodes_view';
export const SETTINGS_EXTERNALCODES_GOOGLE_GA4TOKEN_AUTHORIZE_ATTEMPT =
  'settings_externalcodes_google_ga4token_authorize_attempt';

// SEO REDIRECTS
export const MENU_SECONDARY_SEO_REDIRECTS_CLICK =
  'menu_secondary_seo_redirects_click';

// SOCIAL EVENTS
export const MENU_PRIMARY_SALES_CHANNEL_CLICK =
  'menu_primary_sales_channel_click';

export const MENU_SECONDARY_MARKETPLACES_APPS_CLICK =
  'menu_secondary_meli_apps_click';

export const MENU_PRIMARY_GOOGLE_SHOPPING_CLICK =
  'menu_primary_google_shopping_click';
export const MENU_PRIMARY_TIKTOK_CLICK = 'menu_primary_tiktok_click';
export const MENU_PRIMARY_META_CLICK = 'menu_primary_meta_click';
export const MENU_PRIMARY_PINTEREST_CLICK = 'menu_primary_pinterest_click';

export const MENU_SECONDARY_GOOGLE_SHOPPING_CLICK =
  'menu_secondary_google_shopping_click';
export const MENU_SECONDARY_TIKTOK_CLICK = 'menu_secondary_tiktok_click';
export const MENU_SECONDARY_FACEBOOK_CLICK = 'menu_secondary_facebook_click';

// AI GENERATE EVENTS
export const AI_GENERATE_CTA_CLICK = 'ai_generate_cta_click';
export const AI_GENERATE_GENERATE_CLICK = 'ai_generate_generate_click';
export const AI_GENERATE_CANCEL_CLICK = 'ai_generate_cancel_click';
export const AI_GENERATE_REGENERATE_CLICK = 'ai_generate_regenerate_click';
export const AI_GENERATE_USE_CONTENT_CLICK = 'ai_generate_use_content_click';
export const AI_GENERATE_CONTENT_SELECT = 'ai_generate_content_select';
export const USER_EDIT_NAME = 'user_edit_name';
export const USER_EDIT_DESCRIPTION = 'user_edit_description';
export const USER_EDIT_WEIGHT = 'user_edit_weight';
export const USER_EDIT_DEPTH = 'user_edit_depth';
export const USER_EDIT_WIDTH = 'user_edit_width';
export const USER_EDIT_HEIGHT = 'user_edit_height';
export const USER_EDIT_TAGS = 'user_edit_tags';
export const USER_EDIT_BRAND = 'user_edit_brand';
export const USER_EDIT_SEO_TITLE = 'user_edit_seo_title';
export const USER_EDIT_SEO_DESCRIPTION = 'user_edit_seo_description';

// AI IMAGES EVENTS
export const AI_EDIT_IMAGE_REPLACE_BACKGROUND_WITH_COLOR_CTA_CLICK =
  'ai_edit_img_replace_bg_w_color_cta_click';
export const AI_EDIT_IMAGE_REPLACE_BACKGROUND_WITH_IMAGE_CTA_CLICK =
  'ai_edit_img_replace_bg_w_image_cta_click';

export const AI_EDIT_IMAGE_REPLACE_BACKGROUND_WITH_COLOR_PICK_CLICK =
  'ai_edit_img_replace_bg_w_color_pick_click';
export const AI_EDIT_IMAGE_REPLACE_BACKGROUND_WITH_IMAGE_PICK_CLICK =
  'ai_edit_img_replace_bg_w_image_pick_click';

export const AI_EDIT_IMAGE_REPLACE_BACKGROUND_WITH_COLOR_USE_CLICK =
  'ai_edit_img_replace_bg_w_color_use_click';
export const AI_EDIT_IMAGE_REPLACE_BACKGROUND_WITH_IMAGE_USE_CLICK =
  'ai_edit_img_replace_bg_w_image_use_click';

export const AI_EDIT_IMAGE_SMART_ERASE_CTA_CLICK =
  'ai_edit_img_smart_erase_cta_click';
export const AI_EDIT_IMAGE_SMART_ERASE_ERASE_CLICK =
  'ai_edit_img_smart_erase_canvas_erase_click';
export const AI_EDIT_IMAGE_SMART_ERASE_UNDO_CLICK =
  'ai_edit_img_smart_erase_canvas_undo_click';
export const AI_EDIT_IMAGE_SMART_ERASE_USE_CLICK =
  'ai_edit_img_smart_erase_use_click';

// AI GOOGLE SHOPPING CATEGORIES
export const AI_GOOGLE_SHOPPING_CATEGORIES_USE_CLICK =
  'ai_google_shopping_categories_use_click';

export const AI_PRODUCT_CATEGORY_REMOVE_CLICK =
  'ai_product_category_remove_click';
export const AI_PRODUCT_CATEGORY_FEEDBACK_POSITIVE_CLICK =
  'ai_product_category_feedback_positive_click';
export const AI_PRODUCT_CATEGORY_FEEDBACK_NEGATIVE_CLICK =
  'ai_product_category_feedback_negative_click';

export const MARKETING_AUTOMATION_PAGE_VIEW = 'marketing_automation_page_view';
export const MARKETING_AUTOMATION_INSTALL_CLICK =
  'marketing_automation_install_click';
export const MENU_SECONDARY_MARKETING_AUTOMATION_CLICK =
  'menu_secondary_marketing_automation_click';
export const MENU_SECONDARY_MARKETING_APPS_CLICK =
  'menu_secondary_marketing_apps_click';
export const MENU_SECONDARY_AUTOMATIONS_CLICK =
  'menu_secondary_automations_click';
export const MENU_SECONDARY_EMAIL_MARKETING_CLICK =
  'menu_secondary_email_marketing_click';
export const MARKETING_APPS_VIEW_DETAILS = 'marketing_apps_view_details';

export const CREATE_RELATED_PRODUCT = 'related_product_create';
export const UPDATE_RELATED_PRODUCT = 'related_product_edit';
export const CREATE_RELATED_PRODUCT_MODAL = 'related_product_modal_add_click';
export const UPDATE_RELATED_PRODUCT_MODAL = 'related_product_modal_edit_click';
export const CREATE_RELATED_PRODUCT_CONFIRM =
  'related_product_confirm_add_click';
export const UPDATE_RELATED_PRODUCT_CONFIRM =
  'related_product_confirm_edit_click';

// NUVEMCHAT
export const NUVEMCHAT_MENU_CLICK = 'nuvemchat_menu_click';
export const NUVEMCHAT_INSTALL_CLICK = 'nuvemchat_install_click';
export const NUVEMCHAT_WAITLIST_CLICK = 'nuvemchat_waitlist';
export const NUVEMCHAT_INFO_CLICK = 'nuvemchat_info_click';
// DOMAIN SOFTBLOCK

export const SOFTBLOCK_NAMESERVER_SHOW = 'softblock-nameserver-show';
export const SOFTBLOCK_NAMESERVER_ERROR_SHOW = 'softblock-nameserver-error';
export const SOFTBLOCK_NAMESERVER_SKIP = 'softblock-nameserver-skip ';
export const SOFTBLOCK_NAMESERVER_UPDATED = 'softblock-nameserver-updated';
export const SOFTBLOCK_NAMESERVER_TUTORIAL = 'softblock-nameserver-tutorial';

//NEW ONBOARDING 202411
export const DASHBOARD_SEE_STORE = 'dashboard_see_store_click';
export const DASHBOARD_THEME_PERSONALIZE = 'dashboard_theme_personalize_click';
export const DASHBOARD_REGISTER_LOCATION = 'dashboard_register_location_click';
export const DASHBOARD_MELI_SYNC = 'dashboard_meli_sync_click';
export const DASHBOARD_GO_POS = 'dashboard_go_pos_click';
export const DASHBOARD_MELI_SYNC_DISMISS = 'dashboard_meli_sync_dismiss';
export const DASHBOARD_SEE_PREFERENCES_NUVEM_ENVIO =
  'dashboard_see_preferences_nuvem_envio_click';
export const DASHBOARD_SEE_PREFERENCES_ENVIO_NUBE =
  'dashboard_see_preferences_envio_nube_click';
export const DASHBOARD_SEE_PREFERENCES_NUVEM_PAGO =
  'dashboard_see_preferences_nuvem_pago_click';
export const DASHBOARD_SEE_PREFERENCES_PAGO_NUBE =
  'dashboard_see_preferences_pago_nube_click';
export const DASHBOARD_PAYMENT_OTHERS = 'dashboard_payment_others_click';
export const DASHBOARD_BOLD_CLICK = 'dashboard_bold_click';
export const DASHBOARD_MX_PAGO_NUBE_ACTIVATE =
  'dashboard_mx_pago_nube_activate';
export const DASHBOARD_NUVEMCHAT_SETUP = 'dashboard_nuvemchat_setup_click';

// ONBOARDING FUNNELS (Amplitude)
export const ONBOARDING_SETUP_SHOW = 'onboarding_setup_show';
export const ONBOARDING_SETUP_FINISHED = 'onboarding_setup_finished';
export const ONBOARDING_PROMOTE_SHOW = 'onboarding_promote_show';
export const ONBOARDING_PROMOTE_FINISHED = 'onboarding_promote_finished';

//EMAIL NOTIFICATIONS
export const USER_NOTIFICATION_DISABLED = 'user_notification_disabled';
export const USER_NOTIFICATION_ENABLED = 'user_notification_enabled';

// ECOSYSTEM
export const APPSTORE_HOMEPAGE_CLICK = 'appstore_homepage_click';
export const APPSTORE_APP_INSTALL_CLICK = 'appstore_app_user_install_click';
export const APPSTORE_APP_UNINSTALL_CLICK = 'appstore_app_user_uninstall_click';
export const APPSTORE_APP_CARD_CLICK = 'appstore_app_card_click';
export const APPSTORE_CATEGORY_CLICK = 'appstore_category_explore_more_click';
export const APPSTORE_ADMIN_STARTER_KIT = 'appstore_admin_starter_kit';
export const APPSTORE_ADMIN_STARTER_KIT_VIEW = `${APPSTORE_ADMIN_STARTER_KIT}_view`;

// IMPORT CSV
export const CSV_IMPORT_CLICK = 'csv_import_click';
export const CSV_EXPORT_CLICK = 'csv_export_click';
export const CSV_IMPORT_DOWNLOAD_TEMPLATE_CLICK =
  'csv_import_download_template_click';

//NUVEMPAGO NUDGES EVENTS BANNER
export const ORDERS_NUVEMPAGO_NUDGES_CTA_CLOSE =
  'orders_nuvempago_banner_approvel_rate_close';
export const ORDERS_NUVEMPAGO_NUDGES_CTA_ACTIVE =
  'orders_nuvempago_banner_approvel_rate_active';
export const ORDERS_NUVEMPAGO_NUDGES_CTA_VIEW =
  'orders_nuvempago_banner_approvel_rate_view';

//NUVEMPAGO NUDGES EVENTS CARD
export const ORDERS_NUVEMPAGO_NUDGES_CTA_CLICK_GROUP_3_CLOSE =
  'orders_nuvempago_card_banner_approvel_rate_close';
export const ORDERS_NUVEMPAGO_NUDGES_CTA_CLICK_GROUP_3_ACTIVE =
  'orders_nuvempago_card_banner_approvel_rate_active';
export const ORDERS_NUVEMPAGO_NUDGES_CTA_CLICK_GROUP_3_VIEW =
  'orders_nuvempago_card_banner_approvel_rate_view';

//NUVEMPAGO NUDGES EVENTS ALERT TIP
export const PAYMENTS_NUVEMPAGO_NUDGES_ALERT_TIP_VIEW =
  'payment_methods_nuvempago_card_approvel_rate_view';

// QUESTIONNAIRE
export const PRE_ONBOARDING_BACK_BUTTON_CLICK =
  'pre_onboarding_back_button_click';
export const PRE_ONBOARDING_CONTINUE_BUTTON_CLICK =
  'pre_onboarding_continue_button_click';
export const PRE_ONBOARDING_SKIP_BUTTON_CLICK =
  'pre_onboarding_skip_button_click';
export const PRE_ONBOARDING_RESPONSE = 'pre_onboarding_response';

export const RECOMMENDATION_TASK_CLICK =
  'dashboard_recommendations_tasks_click';

export const DASHBOARD_PROMOTE_TASK_CLICK = 'dashboard_promote_task_click';
export const DASHBOARD_PROMOTE_TASK_SKIP = 'dashboard_promote_task_skip';
export const DASHBOARD_SALE_CHANNEL_RECOMMENDATION_CLICK =
  'dashboard_sale_channel_recommendation_click';

// RECOMMEND PLAN
export const ONBOARDING_RECOMMENDED_PLAN_SCREEN_SHOW =
  'onboarding_recommended_plan_screen_show';
export const ONBOARDING_RECOMMENDED_PLAN_FREE_CLICK =
  'onboarding_recommended_plan_free_click';
export const ONBOARDING_RECOMMENDED_PLAN_TEST_CLICK =
  'onboarding_recommended_plan_test_click';
export const ONBOARDING_RECOMMENDED_SEE_OTHER_PLANS_CLICK =
  'onboarding_recommended_see_other_plans_click';

// REDIRECT TO REGISTRATION PAGE
export const STORE_CREATION_REGISTRATION_DATA_REDIRECT =
  'store_creation_registration_data_redirect';

// STORE CANCELLATION
export const ACCOUNT_STORE_CANCELLATION_START_CLICK =
  'account_store_cancellation_start_click';
export const ACCOUNT_STORE_CANCELLATION_CONFIRM_STEP_ONE_CLICK =
  'account_store_cancellation_confirm_step_one_click';
export const ACCOUNT_STORE_CANCELLATION_CONFIRM_STEP_TWO_CLICK =
  'account_store_cancellation_confirm_step_two_click';
export const ACCOUNT_STORE_CANCELLATION_CONFIRM_STEP_THREE_CLICK =
  'account_store_cancellation_confirm_step_three_click';
export const ACCOUNT_STORE_CANCELLATION_CONFIRM_MODAL_CLICK =
  'account_store_cancellation_confirm_modal_click';

// AI AGENT CHAT EVENTS
export const AI_AGENT_CHAT_MESSAGE_SENT = 'ai_agent_chat_message_sent';
export const AI_AGENT_CHAT_SUGGESTION_USED = 'ai_agent_chat_suggestion_used';
export const AI_AGENT_CHAT_CONVERSATION_RESET =
  'ai_agent_chat_conversation_reset';
export const AI_AGENT_CHAT_ACTION_GENERATED = 'ai_agent_chat_action_generated';
export const AI_AGENT_CHAT_ACTION_ACCEPTED = 'ai_agent_chat_action_accepted';

// Generic AI Feedback Events
export const AI_FEEDBACK_POSITIVE_CLICK = 'ai_feedback_positive_click';
export const AI_FEEDBACK_NEGATIVE_CLICK = 'ai_feedback_negative_click';

export const DASHBOARD_KNOW_NUVEMPAGO_CLICK = 'dashboard_nuvempago_know_click';
export const DASHBOARD_NUVEMPAGO_SETTINGS_CLICK =
  'dashboard_nuvempago_settings_click';
export const NEW_RELEASES_CLICK = 'admin_news_button_click';
